import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tarifa/';

class TarifaService {
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (data ? data.token : '')
      };
    });
  }

  save(tarifa) {
    return axios.post(API_URL + 'salvarTarifa', JSON.stringify(tarifa),
      { headers: this.headers });
  }

  getTarifa(tarifaId) {
    return axios.get(API_URL + 'tarifa/' + tarifaId, { headers: this.headers });
  }

  findAllTarifaByFiltro(idCliente, filtro) {
    return axios.get(API_URL + 'allTarifas?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers });
  }

  findAllTarifasByFiltro(idCliente, idCategoria, filtro) {
    return axios.get(API_URL + 'allTarifaByFiltro?idCliente=' + idCliente + '&idCategoria=' + idCategoria+ '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
  }

  findAllCategoriasByFiltro(idCliente, filtro){
    return axios.get(API_URL + 'allCategoriasByFiltro?idCliente=' + idCliente + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
  }

  ativarTarifa(tarifaId) {
    return axios.post(API_URL + 'ativarTarifa/' + tarifaId, null, { headers: this.headers });
  }

  inativarTarifa(tarifaId, dataInativacao) {
    return axios.post(API_URL + 'inativarTarifa/' + tarifaId + '/' + dataInativacao, null, { headers: this.headers });
  }
}


export default new TarifaService();